<ng-container *ngIf="!showSuccess, else success">
	<div>
		<div class="section-header m-b-20">Business Location</div>
		<form (submit)="addAgentLocation()" [formGroup]="form">

			<!-- <app-input-control [controlDef]="locationName"></app-input-control> -->

			<app-floating-label-input [controlDef]="locationName" label="Location Name" placeHolder="Location Name">
			</app-floating-label-input>

			<!-- <nz-form-item>
				<nz-select [nzSuffixIcon]="customDropDown" name="platform" formControlName="listOfCurrentlyUsedPlatforms"
					style="width: 100%;" nzPlaceHolder="currently used platform" nzMode="multiple">
					<nz-option *ngFor="let item of usedPlatforms" [nzLabel]="item.name" [nzValue]="item.name">
					</nz-option>
				</nz-select>
			</nz-form-item> -->

			<nz-form-item>
				<nz-form-control>
					<div class="custom-floating-input multi-select">
						<nz-select [nzSuffixIcon]="customDropDown" class="custom-select"
								   custom-select formControlName="listOfCurrentlyUsedPlatforms"
								   labelId="listOfCurrentlyUsedPlatforms" nzAllowClear nzMode="multiple" nzShowSearch>
							<nz-option *ngFor="let item of usedPlatforms" [nzLabel]="item.name" [nzValue]="item.name">
							</nz-option>
						</nz-select>
						<label class="select-label" id="listOfCurrentlyUsedPlatforms">Currently Used Platform</label>
					</div>
				</nz-form-control>
			</nz-form-item>

			<app-floating-label-input [controlDef]="estimatedFootFallPerHour" label="Estimated Foot Fall Per Hour"
									  placeHolder="Estimated Foot Fall Per Hour"></app-floating-label-input>

			<app-floating-label-input [controlDef]="withdrawalValueCommitment" label="Withdrawal Value Commitment"
									  placeHolder="Withdrawal Value Commitment"></app-floating-label-input>

			<app-floating-label-input [controlDef]="depositValueCommitment" label="Deposit Value Commitment"
									  placeHolder="Deposit Value Commitment"></app-floating-label-input>

			<!-- <app-input-control [controlDef]="estimatedFootFallPerHour"></app-input-control> -->
			<!-- <app-input-control [controlDef]="Card PaymentValueCommitment"></app-input-control> -->
			<!-- <app-input-control [controlDef]="depositValueCommitment"></app-input-control> -->

			<nz-form-item>
				<label class="custom-file-upload" for="upload-vid">
					<div>
						<ng-container *ngTemplateOutlet="uploadIcon"></ng-container>
					</div>
					<div style="overflow: hidden;">
						<div class="text-bold primary-color" style="overflow-wrap: break-word;">
							{{videoName || 'Location Video'}}
						</div>
						<small>Video formats {{'moniepoint.are_accepted'|translate}}</small>
					</div>
				</label>
				<input (change)="onFileChange($event, 'video')" class="upload-file" formControlName="locationVideo"
					   id="upload-vid"
					   name="vid" type="file"/>
			</nz-form-item>

			<app-custom-error-display [errorMessage]="fileSizeError"></app-custom-error-display>

			<nz-form-item>
				<label class="custom-file-upload" for="upload-photo">
					<div>
						<ng-container *ngTemplateOutlet="uploadIcon"></ng-container>
					</div>
					<div style="overflow: hidden;">
						<div class="text-bold primary-color" style="overflow-wrap: break-word;">
							{{fileName || 'End of Day Picture'}}
						</div>
						<small>PNG, JPG {{'moniepoint.are_accepted'|translate}}</small>
					</div>
				</label>
				<input (change)="onFileChange($event, 'file')" accept="image/jpeg, image/jpg, image/png"
					   class="upload-file"
					   formControlName="endOfDayPicture" id="upload-photo" name="photo" type="file"/>
			</nz-form-item>

			<!-- <app-input-control [controlDef]="addressLineOne"></app-input-control> -->

			<app-floating-label-input [controlDef]="addressLineOne" label="Address" placeHolder="Address">
			</app-floating-label-input>


			<!-- <nz-form-item>
				<nz-select formControlName="state" [nzSuffixIcon]="customDropDown" class="" name="state"
					style="width: 100%;" [nzPlaceHolder]="'State'|translate | titlecase">
					<nz-option *ngFor="let state of states" [nzLabel]="state.name" [nzValue]="state.id">
					</nz-option>
				</nz-select>
			</nz-form-item> -->


			<nz-form-item>
				<nz-form-control>
					<div class="custom-floating-input">
						<nz-select [nzSuffixIcon]="customDropDown" class="custom-select" custom-select
								   formControlName="state" labelId="state" nzAllowClear nzShowSearch>
							<nz-option *ngFor="let state of states" [nzLabel]="state.name" [nzValue]="state.id">
							</nz-option>
						</nz-select>
						<label class="select-label" id="state">State</label>
					</div>
				</nz-form-control>
			</nz-form-item>
			<!--
			<nz-form-item>
				<nz-select [nzSuffixIcon]="customDropDown" class="" formControlName="localGovernmentId" name="lga"
					style="width: 100%;" [nzPlaceHolder]="'Local Government Area'|translate | titlecase">
					<nz-option *ngFor="let item of lgas" [nzLabel]="item.name" [nzValue]="item.id">
					</nz-option>
				</nz-select>
			</nz-form-item> -->

			<nz-form-item>
				<nz-form-control>
					<div class="custom-floating-input">
						<nz-select [nzSuffixIcon]="customDropDown" class="custom-select"
								   custom-select formControlName="localGovernmentId" labelId="localGovernmentId"
								   nzAllowClear
								   nzShowSearch>
							<nz-option *ngFor="let item of lgas" [nzLabel]="item.name" [nzValue]="item.id"></nz-option>
						</nz-select>
						<label class="select-label" id="localGovernmentId">Local Government Area</label>
					</div>
				</nz-form-control>
			</nz-form-item>

			<nz-form-item>
				<label formControlName="locationPhysicallyVisitedByAggregator" nz-checkbox>Location Physically Visited
					by
					BRM</label>
			</nz-form-item>

			<ng-template #customDropDown>
				<svg fill="none" height="8" viewBox="0 0 14 8" width="14" xmlns="http://www.w3.org/2000/svg">
					<path clip-rule="evenodd"
						  d="M13.1363 0.263604C13.4878 0.615076 13.4878 1.18492 13.1363 1.5364L7.7363 6.9364C7.38483 7.28787 6.81498 7.28787 6.46351 6.9364L1.06351 1.5364C0.712035 1.18492 0.712035 0.615075 1.06351 0.263603C1.41498 -0.0878685 1.98483 -0.0878685 2.3363 0.263603L7.0999 5.02721L11.8635 0.263604C12.215 -0.087868 12.7848 -0.087868 13.1363 0.263604Z"
						  fill="black" fill-rule="evenodd"/>
				</svg>
			</ng-template>

			<app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>

			<div [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="m-t-20" nz-row>
				<div [nzSpan]="12" class="gutter-row" nz-col>
					<button (click)="modal.destroy()" class="btn btn-secondary btn-block"
							type="button">{{'moniepoint.cancel'|translate}}</button>
				</div>
				<div [nzSpan]="12" class="gutter-row" nz-col>
					<app-custom-submit-button [block]="true" [submitting]="submittingForm" name="Submit">
					</app-custom-submit-button>
				</div>
			</div>

		</form>
	</div>
</ng-container>
<ng-template #success>
	<app-non-modal-alert (confirm)="closeModal()" [alertType]="'success'" [message]="'Location Successfully Added'">
	</app-non-modal-alert>
</ng-template>

<ng-template #uploadIcon>
	<svg fill="none" height="38" viewBox="0 0 38 38" width="38" xmlns="http://www.w3.org/2000/svg">
		<rect fill="#2AAAE2" fill-opacity="0.15" height="38" rx="12" width="38"/>
		<path clip-rule="evenodd"
			  d="M20.1 16.3V11.35L25.05 16.3M13.8 10C12.801 10 12 10.801 12 11.8V26.2C12 27.1941 12.8059 28 13.8 28H24.6C25.5941 28 26.4 27.1941 26.4 26.2V15.4L21 10H13.8Z"
			  fill="#0361F0" fill-rule="evenodd"/>
	</svg>
</ng-template>
